import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { MdFlight, MdFoodBank, MdHotel } from "react-icons/md";
import user from "../../../images/user.jpg";
import { FaEnvelope } from "react-icons/fa";
import pkgImg from "../../../images/task/pic4.jpg";

//images

import RoomSlider from "./Guest/RoomSlider";
import ReactStars from "react-stars";

const DropdownBlog = () => {
  return (
    <>
      <Dropdown className="dropdown dropend ms-auto">
        <Dropdown.Toggle as="div" className="btn-link i-false">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
              stroke="#575757"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
              stroke="#575757"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
              stroke="#575757"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item>Send Invoice</Dropdown.Item>
          <Dropdown.Item>Edit</Dropdown.Item>
          <Dropdown.Item>Delete</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

const CustomerDetails = () => {
  const { guestId } = useParams();
  const [selectBtn, setSelectBtn] = useState("Newest");
  const [loading, setLoading] = useState(false);
  const [modalData, setModal] = useState({ show: false, message: "" });
  const [customer, setCustomer] = useState({
    personalDetails: {
      id: "lksdfjlkdsf",
      name: "John Smith",
      mobileNo: "+91 123 456 7890",
      emailId: "john@smith.com",
      profilePic: "",
      address: "A-1 XYZ Street, California, USA",
      totalBookings: 12,
      lastBookingDate: new Date("2024, 12, 16"),
      status: "Active",
      preferences: [
        {
          title: "Preferred Meal",
          description: "Vegetarian with no spicy food",
        },
        {
          title: "Seating Preference",
          description: "Aisle seat for flights and trains",
        },
        {
          title: "Room Preference",
          description: "Non-smoking, with a king-size bed",
        },
        {
          title: "Allergies",
          description: "Peanuts and shellfish",
        },
        {
          title: "Preferred Communication",
          description: "Email for notifications, no phone calls after 8 PM",
        },
        {
          title: "Special Assistance",
          description: "Wheelchair assistance at the airport",
        },
        {
          title: "Favorite Activities",
          description: "Hiking, city tours, and local cultural experiences",
        },
      ],
    },
    bookingDetails: {
      id: "LSD9033",
      packageName: "Dubai",
      imageUrl: "",
      startDate: new Date("2024, 12, 10"),
      endDate: new Date("2024, 12, 25"),
      status: "In Progress",
      facilities: ["Visa", "Airport Transfers", "1 Activity"],
      specialRequest: "Nothing!",
    },
    bookingHistories: [
      {
        id: "SLS9200",
        packageName: "Dubai",
        imageUrl: "",
        travelDates: [new Date("2024, 12, 10"), new Date("2024, 12, 25")],
        status: "In Progress",
        totalCost: "250",
        assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
        specialRequest: "Nothing!",
        feedback: 4.0,
      },
      {
        id: "SLS9200",
        packageName: "Kashmir",
        imageUrl: "",
        travelDates: [new Date("2023, 02, 10"), new Date("2024, 02, 15")],
        status: "Completed",
        totalCost: "250",
        assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
        specialRequest: "Nothing!",
        feedback: 4.2,
      },
      {
        id: "SLS9200",
        packageName: "Dubai",
        imageUrl: "",
        travelDates: [new Date("2024, 12, 10"), new Date("2024, 12, 25")],
        status: "In Progress",
        totalCost: "250",
        assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
        specialRequest: "Nothing!",
        feedback: 4.9,
      },
      {
        id: "SLS9200",
        packageName: "Dubai",
        imageUrl: "",
        travelDates: [new Date("2024, 12, 10"), new Date("2024, 12, 25")],
        status: "In Progress",
        totalCost: "250",
        assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
        specialRequest: "Nothing!",
        feedback: 4.0,
      },
    ],
  });

  const getCustomerDetails = async () => {
    setLoading(true);
    const response = {
      status: 200,
      data: {
        personalDetails: {
          id: "lksdfjlkdsf",
          name: "John Smith",
          mobileNo: "+91 123 456 7890",
          emailId: "john@smith.com",
          profilePic: "",
          address: "A-1 XYZ Street, California, USA",
          totalBookings: 12,
          lastBookingDate: new Date("2024, 12, 16"),
          status: "Active",
          preferences: [
            {
              title: "Preferred Meal",
              description: "Vegetarian with no spicy food",
            },
            {
              title: "Seating Preference",
              description: "Aisle seat for flights and trains",
            },
            {
              title: "Room Preference",
              description: "Non-smoking, with a king-size bed",
            },
            {
              title: "Allergies",
              description: "Peanuts and shellfish",
            },
            {
              title: "Preferred Communication",
              description: "Email for notifications, no phone calls after 8 PM",
            },
            {
              title: "Special Assistance",
              description: "Wheelchair assistance at the airport",
            },
            {
              title: "Favorite Activities",
              description: "Hiking, city tours, and local cultural experiences",
            },
          ],
        },
        bookingDetails: {
          id: "LSD9033",
          packageName: "Dubai",
          startDate: new Date("2024, 12, 10"),
          endDate: new Date("2024, 12, 25"),
          status: "In Progress",
          facilities: ["Visa", "Airport Transfers", "1 Activity"],
          specialRequest: "Nothing!",
        },
        bookingHistories: [
          {
            id: "SLS9200",
            packageName: "Dubai",
            imageUrl: "",
            travelDates: [new Date("2024, 12, 10"), new Date("2024, 12, 25")],
            status: "In Progress",
            totalCost: "250",
            assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
            specialRequest: "Nothing!",
            feedback: 4.0,
          },
          {
            id: "SLS9200",
            packageName: "Dubai",
            imageUrl: "",
            travelDates: [new Date("2024, 12, 10"), new Date("2024, 12, 25")],
            status: "In Progress",
            totalCost: "250",
            assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
            specialRequest: "Nothing!",
            feedback: 4.5,
          },
          {
            id: "SLS9200",
            packageName: "Dubai",
            imageUrl: "",
            travelDates: [new Date("2024, 12, 10"), new Date("2024, 12, 25")],
            status: "Cancelled",
            totalCost: "250",
            assignedEmployee: { id: "289309sfdsdf", name: "Martin" },
            specialRequest: "Nothing!",
            feedback: 3.2,
          },
        ],
      },
    }; // axios.post()
    if (response.status === 200) {
      setCustomer({ ...response.data });
    }
    setLoading(false);
  };

  const handleShowModal = (message) => {
    setModal({ show: true, message });
  };

  useEffect(() => {
    getCustomerDetails();
  }, [guestId]);

  return (
    <>
      <Modal
        show={modalData.show}
        onHide={() => setModal((curr) => ({ ...curr, show: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>Special Request</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalData?.message ? (
            <p style={{ fontSize: "16px", fontWeight: 600 }}>
              {modalData.message}
            </p>
          ) : (
            <p style={{ fontSize: "12px" }}>No special request provided.</p>
          )}
        </Modal.Body>
      </Modal>
      {loading ? (
        <p className="text-center">Loading...</p>
      ) : (
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="card overflow-hidden">
                  <div className="row m-0">
                    <div className="col-xl-6 p-0">
                      <div className="card-body">
                        <div className="guest-profile">
                          <div className="d-flex items-c">
                            <img
                              src={customer.personalDetails.profilePic || user}
                              alt=""
                              className="my-auto"
                            />
                            <div>
                              <h2 className="font-w600">
                                {customer.personalDetails.name}
                              </h2>
                              <h5>
                                <strong>Address: </strong>
                                {customer.personalDetails.address}
                              </h5>
                              <h5>
                                <strong>Status: </strong>
                                <span
                                  className={`${
                                    customer.personalDetails.status === "Active"
                                      ? "text-green-600"
                                      : "text-red-600"
                                  }`}
                                >
                                  {customer.personalDetails.status}
                                </span>
                              </h5>
                              <div className="call d-flex align-items-center gap-x-2">
                                <Link
                                  to={`phone:${customer.personalDetails.mobileNo}`}
                                >
                                  <i className="fas fa-phone-alt text-secondary"></i>
                                </Link>
                                <Link
                                  to={`mailto:${customer.personalDetails.emailId}`}
                                  className="bg-secondary text-white"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <FaEnvelope />
                                </Link>
                              </div>
                            </div>
                            <DropdownBlog />
                          </div>
                        </div>

                        <div className="mt-3">
                          <h3>Current Booking Details</h3>
                          <div className="flex flex-col gap-y-3 mt-3">
                            <div className="flex flex-row justify-between">
                              <h5>
                                Package Name <br />
                                {customer.bookingDetails.packageName}
                              </h5>
                              <div>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    as="div"
                                    className="btn-select-drop default-select btn i-false"
                                  >
                                    In Progress
                                    <i className="fas fa-angle-down ms-2"></i>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item>Booked</Dropdown.Item>
                                    <Dropdown.Item>Confirmed</Dropdown.Item>
                                    <Dropdown.Item>Completed</Dropdown.Item>
                                    <Dropdown.Item>Cancelled</Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                            <div className="flex flex-row justify-between">
                              <h5>
                                Start Date <br />
                                {new Date(
                                  customer.bookingDetails.startDate
                                ).toLocaleDateString()}
                              </h5>
                              <h5>
                                End Date <br />
                                {new Date(
                                  customer.bookingDetails.endDate
                                ).toLocaleDateString()}
                              </h5>
                            </div>
                            <div className="flex flex-row justify-between gap-x-4">
                              <button
                                type="button"
                                className="btn gradient_one w-full text-white"
                                style={{
                                  fontSize: "16px",
                                  borderRadius: "8px ",
                                }}
                                onClick={() =>
                                  handleShowModal(
                                    customer.bookingDetails.specialRequest || ""
                                  )
                                }
                              >
                                Special Request
                              </button>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  width: "100%",
                                  borderRadius: "8px",
                                  background:
                                    "linear-gradient(to right, rgba(33, 45, 96, 0.85), rgba(63, 196, 147, 0.933))",
                                  padding: "2px", // Creates space for the border effect
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn w-full text-secondary"
                                  style={{
                                    fontSize: "16px",
                                    background: "#fff", // Button background
                                    border: "none", // Remove default border
                                    width: "100%",
                                    borderRadius: "5px",
                                  }}
                                >
                                  Send Invoice
                                </button>
                              </div>
                            </div>
                            <div className="facilities">
                              <h4 className="d-block mb-3">Facilities</h4>
                              <div className="mb-3 grid grid-cols-2">
                                <Link
                                  to={"#"}
                                  className="btn btn-secondary light btn-lg"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="flex justify-center mr-2"
                                    style={{
                                      fontSize: "22px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <MdHotel />
                                  </div>
                                  <p className="my-auto">5 Star Hotel</p>
                                </Link>
                                <Link
                                  to={"#"}
                                  className="btn btn-secondary light btn-lg text-center"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    className="flex justify-center mr-1"
                                    style={{
                                      fontSize: "18px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <MdFlight />
                                  </span>
                                  <p className="my-auto">Round Trip Flights</p>
                                </Link>
                                <Link
                                  to={"#"}
                                  className="btn btn-secondary light btn-lg text-center"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    className="flex justify-center mr-1"
                                    style={{
                                      fontSize: "25px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <MdFoodBank />
                                  </span>
                                  Selected Meals
                                </Link>
                              </div>
                              {customer.bookingDetails.facilities.map(
                                (facility) => (
                                  <Link
                                    to={"#"}
                                    className="btn btn-secondary light"
                                    key={facility}
                                  >
                                    {facility}
                                  </Link>
                                )
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Customer Preferences Section */}
                        <div className="mt-5">
                          <h3>Customer Preferences</h3>
                          <div className="preferences-list flex flex-col gap-y-3 mt-3">
                            {customer.personalDetails.preferences.map(
                              (preference, index) => (
                                <div
                                  key={index}
                                  className="flex flex-row justify-between"
                                >
                                  <h5>{preference.title}</h5>
                                  <p>{preference.description}</p>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-6 p-0">
                      <RoomSlider />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header border-0">
                    <h4 className="fs-20">Booking History</h4>
                    <div className="newest ms-3">
                      {/* <select className="default-select">
											<option>Newest</option>
											<option>Oldest</option>
										</select> */}
                      <Dropdown>
                        <Dropdown.Toggle
                          as="div"
                          className=" btn-select-drop default-select btn i-false"
                        >
                          {selectBtn}{" "}
                          <i className="fas fa-angle-down ms-2 "></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setSelectBtn("Oldest")}>
                            Oldest
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setSelectBtn("Newest")}>
                            Newest
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="card-body pt-0 table-responsive">
                    <table className="table w-full">
                      <thead>
                        <tr className="text-center">
                          <th className="w-[40%]">Package</th>
                          <th className="w-[15%]">Status</th>
                          <th className="w-[4%]">Total Cost</th>
                          <th className="w-[15%]">Special Request</th>
                          <th className="w-full">Feedback</th>
                          <th className="w-[5%]">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customer.bookingHistories.map((history) => (
                          <tr key={history.checkIn} className="w-full">
                            <td className="w-[40%]">
                              <div className="flex flex-col xl:flex-row align-items-center">
                                <img
                                  src={history.imageUrl || pkgImg}
                                  alt=""
                                  className="lg:w-[300px] w-full rounded-lg me-2"
                                />
                                <div>
                                  <h4 className="mb-1">
                                    <strong>Package Name: </strong>
                                    {history.packageName}
                                  </h4>
                                  <span className="fs-16">
                                    Duration:{" "}
                                    {new Date(
                                      history.travelDates[0]
                                    ).toLocaleDateString()}{" "}
                                    -{" "}
                                    {new Date(
                                      history.travelDates[1]
                                    ).toLocaleDateString()}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="text-black my-auto h-full w-[15%]">
                              <Dropdown>
                                <Dropdown.Toggle
                                  as="div"
                                  className="btn-select-drop default-select btn i-false"
                                >
                                  {history.status}
                                  <i className="fas fa-angle-down ms-2"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item>Booked</Dropdown.Item>
                                  <Dropdown.Item>Confirmed</Dropdown.Item>
                                  <Dropdown.Item>Completed</Dropdown.Item>
                                  <Dropdown.Item>Cancelled</Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td className="text-black w-[6%]">
                              <span className="fs-18 font-w500">
                                ${history.totalCost}
                              </span>
                            </td>
                            <td className="text-black w-[15%]">
                              <button
                                type="button"
                                className="btn gradient_one text-white w-100"
                                onClick={() =>
                                  handleShowModal(history.specialRequest || "")
                                }
                              >
                                Special Request
                              </button>
                            </td>
                            <td className="text-black w-full text-nowrap">
                              <ReactStars
                                value={history.feedback}
                                count={5}
                                size={24}
                                color2={"#ffd700"}
                                className="font-w500 w-full fs-18"
                              />
                            </td>
                            <td className=" w-[5%]">
                              <DropdownBlog />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default CustomerDetails;
